/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { UserSearchEntity } from '@axiom/domain';
/**
 * Response projection of the UserSearch entity. Extends UserSearchEntity
 * (inherits `static key = 'UserSearch'`), so this projection and the full
 * UserSearch entity merge into the same normalized cache record.
 * dark-roast DTO: UserSearchesResponseDto
 * also used by readUsersSearches
 */
export class ReadUsersSearchResponseEntity extends UserSearchEntity {
}